import { render } from "./AssetInfoForm.vue?vue&type=template&id=c2ffb91e&scoped=true"
import script from "./AssetInfoForm.vue?vue&type=script&lang=js"
export * from "./AssetInfoForm.vue?vue&type=script&lang=js"

import "./AssetInfoForm.vue?vue&type=style&index=0&id=c2ffb91e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2ffb91e"]])

export default __exports__